// Hints the browser to open early connections to third-party origins used by
// this page, so the actual requests (fonts, CDN assets) don't pay the full
// DNS + TCP + TLS handshake cost when they're first requested.
const PRECONNECT_ORIGINS = [
  'https://cdn.magicpatterns.com',
  'https://md-eecad2978f7a43f5b7838c919258e6de.ecs.us-east-2.on.aws',
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com'
];

export function setupPreconnects() {
  if (typeof document === 'undefined') return;

  PRECONNECT_ORIGINS.forEach((origin) => {
    const existing = document.querySelector(`link[rel="preconnect"][href="${origin}"]`);
    if (existing) return;

    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}
